import Modal from '@components/Modal'
import Typography, { FontType } from '@components/UI/Typography'
import { theme } from '@resources/theme'
import Separator from '@components/UI/Separator'

import { IProps } from './types'
import * as SC from './styles'

const ModalDetail = ({ display, closeModal }: IProps) => {
  const data =
    '<!DOCTYPE html> <html> <body> <h3>Disponível para 3 tempos gráficos: 15 , 60 e 240 minutos</h3> <p>Mercado Lateral: Oportunidades em Movimento Horizontal No dinâmico cenário cambial brasileiro, identificamos uma realidade intrigante - boa parte do ano é caracterizada por movimentos laterais, ou seja, períodos sem uma clara tendência. Imagine isso como uma vasta extensão de oceano aparentemente calmo. Mas, como surfistas financeiros, reconhecemos que mesmo em águas aparentemente tranquilas, há ondas de oportunidades.</p> <p>Ao compreender a natureza do mercado lateral, capturamos a atenção de nossos clientes, apresentando a eles um oceano de potenciais lucros escondidos sob a superfície aparentemente serena do mercado cambial.</p> <h3>Operando Sistema de Volatilidade: Navegando nas Ondas do Mercado</h3> <p>Imagine a volatilidade como as ondas que se formam no oceano. Uma estratégia de volatilidade é como surfar nessas ondas de mudanças de preço. Quando os preços estão em ascensão e queda rápida, nossa abordagem nos permite capitalizar esses movimentos para realizar negociações lucrativas.</p> <p>Como surfistas habilidosos, aproveitamos a agitação do mercado para posicionar nossos clientes estrategicamente, semelhante a surfar em uma onda para obter resultados vantajosos. Essa é a nossa proposta - aproveitar a volatilidade para alcançar o sucesso financeiro.</p> <h3>Trestles - Estratégia com Canal de Keltner: Tendência e Movimento Sutil</h3> <p>Aqui, mergulhamos na aplicação prática com o Canal de Keltner no período 20. Este canal revela a "tendência de curto prazo", muitas vezes imperceptível em um cenário lateral. Visualizamos suportes, resistências móveis e autorizações para ações específicas.</p> <p>Ao apresentar um sistema operacional robusto, inspirado no Canal de Keltner, destacamos a importância de perceber tendências sutis que outros podem perder. É como oferecer aos nossos clientes óculos especiais para enxergar oportunidades onde outros veem apenas estabilidade.</p> </body> </html>'
  const createMarkup = () => {
    return { __html: data }
  }

  return (
    <Modal
      display={display}
      onClose={closeModal}
      title={
        <Typography
          fontType={FontType.bold}
          color={theme.palette.primary.lightest}
          size={25}
        >
          Mercado Lateral ou Sem tendência
        </Typography>
      }
      width={780}
      height={550}
    >
      <SC.SectionMain>
        <SC.WrapperField>
          <Typography
            fontType={FontType.medium}
            color={theme.palette.neutral.regular}
            size={16}
          >
            Descrição:
          </Typography>
          <Separator verticalSize={5} />

          <SC.WrapperDescription>
            <Typography
              fontType={FontType.regular}
              color={theme.palette.primary.light}
              size={14}
            >
              <div dangerouslySetInnerHTML={createMarkup()} />
            </Typography>
          </SC.WrapperDescription>
        </SC.WrapperField>
      </SC.SectionMain>
    </Modal>
  )
}

export default ModalDetail
